export enum AddressActions {
  GetAddress = '[Pending] Get Address',
  GetAddressSuccess = '[Success] Get Address',
  GetAddressError = '[Error] Get Address',
}
